// initial state
const state = {
    naf: null,
    applicationType: "Consumer",
    loanType: "1",
    assetType: "",
    financeDetails: {
        applicationType: '',
        loanType: '',
        sellerType: '',
        repaymentFrequency: '',
        repaymentAmount: '0.00',
        repaymentTerm: '',
        amountToFinance: '0.00', // purchase price
        deposit: '0.00',
        balloon: '',
        amountToFinanced: '0.00',
        trade: '0.00',
        payout: '0.00',
        paymentType:1,

    },
    sellerType: "1",
    leadType:null,
    applicationJoin: "single",
    noOfApplicants: 1,
};

const getters = {
    naf: state => {
        return state.naf
    },

    applicationType: state => {
        return state.applicationType;
    },
    loanType: state => {
        return state.loanType;
    },
    assetType: state => {
        return state.assetType;
    },
    sellerType: state => {
        return state.sellerType;
    },
    applicationJoin: state => {
        return state.applicationJoin;
    },
    financeDetails: state => {
        return state.financeDetails;
    },
    leadType: state => {
        return state.leadType;
    },
    noOfApplicants: state => {
        return state.noOfApplicants;
    }
};

const mutations = {
    saveNaf(state, value) { state.naf = value },

    saveNoOfApplicants(state, value) {state.noOfApplicants = value},
    saveApplicationType(state, type) { state.applicationType = type },
    saveLoanType(state, type) { state.loanType = type },
    saveAssetType(state, type) { state.assetType = type },
    saveSellerType(state, type) { state.sellerType = type },
    saveApplicationJoin(state, type) { state.applicationJoin = type },
    saveFinanceDetails(state, details) { state.financeDetails = details },
    setAmountToFinance(state, value) { state.financeDetails.amountToFinance = value }, //purchase price
    setDeposit(state, value) { state.financeDetails.deposit = value },
    setBalloon(state, value) { state.financeDetails.balloon = value },
    setAmountToFinanced(state, value) { state.financeDetails.amountToFinanced = value }, //purchase price
    setTrade(state, value) { state.financeDetails.trade = value },
    setPayout(state, value) { state.financeDetails.payout = value },
    setRepaymentFrequency(state, value) { state.financeDetails.repaymentFrequency = value },
    setRepaymentTerm(state, value) { state.financeDetails.repaymentTerm = value },
    setRepaymentAmount(state, value) { state.financeDetails.repaymentAmount = value },
    setApplicationType(state, value) {
        state.applicationType = value == 1 || value == null ? "Consumer" : "Commercial"
        state.financeDetails.applicationType = value;
    },
    setApplicationJoin(state, value) { state.applicationJoin = value },
    setPaymentType(state, value) { state.financeDetails.paymentType = value },
    setLoanType(state, value) { state.financeDetails.loanType = value },
    setSellerType(state, value) { state.financeDetails.sellerType = value },
    setLeadType(state, value) {state.leadType = value},
};

const actions = {
    saveNaf(context, value) {
        context.commit('saveNaf', value)
    },

    saveApplicationType(context, type) {
        context.commit("saveApplicationType", type);
    },
    saveLoanType(context, type) {
        context.commit("saveLoanType", type);
    },
    saveAssetType(context, type) {
        context.commit("saveAssetType", type);
    },
    saveSellerType(context, type) {
        context.commit("saveSellerType", type);
    },
    saveApplicationJoin(context, type) {
        context.commit("saveApplicationJoin", type);
    },
    saveFinanceDetails(context, details) {
        context.commit("saveFinanceDetails", details);
    },
    saveLeadType(context, type) {
        context.commit("saveLeadType", type);
    },
    saveNoOfApplicants(context, value) {
        context.commit("saveNoOfApplicants", value);
    },
    setAmountToFinance(context, value) {
        context.commit("setAmountToFinance", value);
    },
    setTrade(context, value) {
        context.commit("setTrade", value);
    },
    setPayout(context, value) {
        context.commit("setPayout", value);
    },
    setDeposit(context, value) {
        context.commit("setDeposit", value);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
